import { FaClipboardList, FaServer, FaUserFriends } from "react-icons/fa";
import { IDashboard } from "../route.type";
import DashboardPage from "../../modules/dashboard/pages/dashboard.page";
import { DemandInventoryPage } from "../../modules/stock-operation/pages/demand-inventory.page";
import { PendingOperationPage } from "../../modules/stock-operation/pages/pending-operation.page";
import { LogoComponent } from "../../branding/logo.component";
import { UserProfilePage } from "../../modules/user/pages/user-profile.page";
import OperationDetailsPage from "../../modules/report/pages/all-operation-details.page";
import MonthlyProductReportPage from "../../modules/report/pages/monthly-product-report.page";
import DailyProductReportPage from "../../modules/report/pages/daily-product-report.page";
import ApprovalOperationDetailsPage from "../../modules/stock-operation/pages/approval-operation-details.page";
import { EditTransferPage } from "../../modules/stock-operation/pages/edit-transfer.page";
import LocationOperationsPage from "../../modules/report/pages/location-operations.page";
import LocationInventoryPage from "../../modules/report/pages/location-inventory.page";
import InventoryByDatePage from "../../modules/report/pages/inventory-by-date.page";
import { ConsumptionPage } from "../../modules/stock-operation/pages/consumption.page";
import { DistributionPage } from "../../modules/stock-operation/pages/distribution.page";
import { TrashPage } from "../../modules/stock-operation/pages/trash.page";
import { AdjustmentReportPage } from "../../modules/report/pages/adjustment-report.page";
import { DemanFulfillPage } from "../../modules/stock-operation/pages/deman-fulfill.page";
import { ChangePasswordPage } from "../../modules/auth/pages/change-password.page";
import { SingleProductMovementByDatePage } from "../../modules/report/pages/single-product-movement-by-date.page";
import { SingleProductMovementByLocationPage } from "../../modules/report/pages/single-product-movement-by-location.page";
import { AllNotificationComponent } from "../../modules/notification/component/all-notification.component";
import { LowStockPage } from "../../modules/dashboard/pages/low-stock.page";
import { ToBeExpiredPage } from "../../modules/dashboard/pages/to-be-expired.page";

export const wardManagerDashboard: IDashboard = {
  dashboardName: "WARDMANAGER",
  logo: <LogoComponent />,
  pages: [
    {
      name: "Items To Be expired",
      link: "/ward-manager/to-be-expired",
      content: <ToBeExpiredPage />
    },
    {
      name: "Low Stock Products",
      link: "/ward-manager/low-stock",
      content: <LowStockPage />
    },
    {
      name: "All Notification",
      link: "/ward-manager/notification-all",
      content: <AllNotificationComponent />
    },
    {
      name: "Dashboard",
      link: "/ward-manager/dashboard",
      content: <DashboardPage />
    },
    {
      name: "Demand",
      link: "/ward-manager/stock-operation/demand/create",
      content: <DemandInventoryPage />
    },
    {
      name: "Pending Operation",
      link: "/ward-manager/stock-operation/pending-operation",
      content: <PendingOperationPage />
    },
    {
      name: "Demand Fulfill",
      link: "/ward-manager/demand-fulfil/:id",
      content: <DemanFulfillPage />
    },
    {
      name: "Approval Operation Details",
      link: "/ward-manager/approval/operation-details",
      content: <ApprovalOperationDetailsPage />
    },
    {
      name: "Edit Transfer Operation",
      link: "/ward-manager/stock-operation/transfer/edit/:operationId",
      content: <EditTransferPage />
    },
    {
      name: "Distribution",
      link: "/ward-manager/distribution",
      content: <DistributionPage />
    },
    {
      name: "Trash",
      link: "/ward-manager/stock-operation/trash/create",
      content: <TrashPage />
    },
    {
      name: "Consumption",
      link: "/ward-manager/stock-operation/consumption/create",
      content: <ConsumptionPage />
    },
    // Reports
    {
      name: "Location Operations",
      link: "/ward-manager/report/location-operations",
      content: <LocationOperationsPage />
    },
    {
      name: "Location Inventory",
      link: "/ward-manager/report/location-inventory",
      content: <LocationInventoryPage />
    },
    {
      name: "Inventory By Date",
      link: "/ward-manager/report/previous-inventory",
      content: <InventoryByDatePage />
    },
    {
      name: "Daily Product Report",
      link: "/ward-manager/report/daily-product-report",
      content: <DailyProductReportPage />
    },
    {
      name: "Monthly Product Report",
      link: "/ward-manager/report/monthly-product-report",
      content: <MonthlyProductReportPage />
    },
    {
      name: "Operation Details",
      link: "/ward-manager/report/operation-details/:id",
      content: <OperationDetailsPage />
    },
    // My Profile
    {
      name: "Profile",
      link: "/ward-manager/profile",
      content: <UserProfilePage />
    },
    {
      name: "Reset Password",
      link: "/ward-manager/change-password",
      content: <ChangePasswordPage />
    },
    {
      name: "Adjustment Report",
      link: "/ward-manager/report/adjustment-report",
      content: <AdjustmentReportPage />
    },
    {
      name: "Single Product Movement (By Date)",
      link: "/ward-manager/report/date-wise-product-movement",
      content: <SingleProductMovementByDatePage />
    },
    {
      name: "Single Product Movement (By Location)",
      link: "/ward-manager/report/single-product-movement",
      content: <SingleProductMovementByLocationPage />
    }
  ],

  sidebar: [
    {
      name: "Dashboard",
      link: "/ward-manager/dashboard",
      content: <DashboardPage />
    },

    {
      header: "Stock Operation",
      icon: FaServer,
      pages: [
        {
          name: "Distribution",
          link: "/ward-manager/distribution",
          content: <DistributionPage />
        },
        {
          name: "Demand",
          link: "/ward-manager/stock-operation/demand/create",
          content: <DemandInventoryPage />
        },
        {
          name: "Trash",
          link: "/ward-manager/stock-operation/trash/create",
          content: <TrashPage />
        },
        {
          name: "Consumption",
          link: "/ward-manager/stock-operation/consumption/create",
          content: <ConsumptionPage />
        },
        {
          name: "Pending Operation",
          link: "/ward-manager/stock-operation/pending-operation",
          content: <PendingOperationPage />
        }
      ]
    },
    {
      header: "Report",
      icon: FaClipboardList,
      pages: [
        {
          name: "Location Operations",
          link: "/ward-manager/report/location-operations",
          content: <LocationOperationsPage />
        },
        {
          name: "Location Inventory",
          link: "/ward-manager/report/location-inventory",
          content: <LocationInventoryPage />
        },
        {
          name: "Inventory By Date",
          link: "/ward-manager/report/previous-inventory",
          content: <InventoryByDatePage />
        },
        {
          name: "Daily Product Report",
          link: "/ward-manager/report/daily-product-report",
          content: <DailyProductReportPage />
        },
        {
          name: "Monthly Product Report",
          link: "/ward-manager/report/monthly-product-report",
          content: <MonthlyProductReportPage />
        },
        {
          name: "Adjustment Report",
          link: "/ward-manager/report/adjustment-report",
          content: <AdjustmentReportPage />
        },
        {
          name: "Single Product Movement (By Location)",
          link: "/ward-manager/report/single-product-movement",
          content: <SingleProductMovementByLocationPage />
        },
        {
          name: "Single Product Movement (By Date)",
          link: "/ward-manager/report/date-wise-product-movement",
          content: <SingleProductMovementByDatePage />
        }
      ]
    },
    {
      header: "User",
      icon: FaUserFriends,
      pages: [
        {
          name: "Profile",
          link: "/ward-manager/profile",
          content: <UserProfilePage />
        }
      ]
    }
  ]
};
